export default "__VITE_ASSET__L8S_9mj1__"